<div class="cds-px-8 cds-py-14 cds-w-full cds-flex cds-h-fit cds-justify-center">
  <div class="cds-flex cds-flex-col cds-w-full lg:cds-w-[1061px]">
    <div class="cds-flex cds-flex-col lg:cds-mt-16 cds-mb-4">
      <div class="cds-flex cds-justify-between cds-items-center">
        <h3>All Quotes</h3>
        <button
          cbButton
          class="!cds-w-fit !cds-px-6 !cds-py-3 md:!cds-px-10 md:!cds-py-3"
          label="New QFA"
          variant="secondary"
          colorTheme="purple"
          iconColor="purple-branding"
          leftIcon="utility-add"
          (click)="addNewQFA()"
          data-testid="dashboard-view-policy-button"></button>
      </div>
      <div class="cds-flex cds-gap-2 cds-justify-end cds-mt-10">
        <button
          class="cds-p-1 cds-stroke-none cds-bg-transparent disabled:cds-cursor-not-allowed"
          (click)="toggleResultsView()"
          [disabled]="!policySummaries() || policySummaries().length < 1"
          data-testid="dashboard-view-as-table-button">
          <cb-icon
            iconKey="utility-view-list-stroke"
            iconSize="large"
            [iconColor]="
              policySummaries() && isTableView && policySummaries().length > 0 ? 'neutral-black' : 'neutral-400'
            " />
        </button>
        <button
          class="cds-p-1 cds-stroke-none cds-bg-transparent disabled:cds-cursor-not-allowed"
          (click)="toggleResultsView()"
          [disabled]="!policySummaries() || policySummaries().length < 1"
          data-testid="dashboard-view-as-grid-button">
          <cb-icon
            iconKey="utility-view-grid-stroke"
            iconSize="large"
            [iconColor]="
              policySummaries() && !isTableView && policySummaries().length > 0 ? 'neutral-black' : 'neutral-400'
            " />
        </button>
      </div>
    </div>
    @if (policySummaries() != null && policySummaries().length > 0) {
      <!-- Table -->
      @if (isTableView) {
        <div class="p-datatable-table-container">
          <p-table
            class="cb-table cb-table--underline cb-table--header-cell-text-align-left cb-table--cell-text-align-left"
            [value]="policySummaries()"
            [resizableColumns]="true"
            [scrollable]="true"
            [globalFilterFields]="['updatedDate']"
            data-testid="dashboard-variants-table">
            <!-- <ng-template pTemplate="caption"> </ng-template> for any global buttons and searches -->
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" id="updatedDate" pResizableColumn pSortableColumn="updatedDate">
                  <span>
                    Date Created
                    <p-columnFilter
                      type="date"
                      field="updatedDate"
                      display="menu"
                      placeholder="dd/mm/yyyy"
                      [showOperator]="false"
                      data-testid="dashboard-table-created-date-filter" />
                    <cb-table-sort field="updatedDate" />
                  </span>
                </th>
                <th scope="col" id="number" pResizableColumn pSortableColumn="number">Policy Number</th>
                <th scope="col" id="adviserCode" pResizableColumn>Advisor Code</th>
                <th scope="col" id="premium" pResizableColumn pSortableColumn="premium">
                  <span>
                    Premium
                    <cb-table-sort field="premium" />
                  </span>
                </th>
                <th scope="col" id="comment" pResizableColumn>Comment</th>
                <th scope="col" pFrozenColumn [frozen]="isMobile" alignFrozen="right" class="cds-z-[10] sm:cds-z-[1]">
                  Download
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-summary>
              <tr>
                <td>{{ summary.updatedDate | date: 'd MMMM yyyy' }}</td>
                <td>
                  <cb-text-link
                    linkColor="black"
                    class="[&>a]:!cds-m-0"
                    [label]="summary?.number"
                    [linkConfiguration]="{
                      target: '_self',
                      href: './coverage?policyNumber=' + summary.number,
                    }" />
                </td>
                <td>{{ summary.adviserCode }}</td>
                <td>
                  {{ formatPremium(summary.premium) }}
                </td>
                <td class="cds-whitespace-nowrap cds-overflow-hidden cds-text-ellipsis" [title]="summary.comment ?? ''">
                  {{ summary.comment }}
                </td>
                <td pFrozenColumn [frozen]="isMobile" alignFrozen="right" class="cds-z-[10] sm:cds-z-[1]">
                  @if (variantDownloadQueue().includes(summary.number)) {
                    <p-progress-spinner
                      [style]="{
                        width: '24px',
                        height: '24px',
                        padding: '4px',
                        display: 'flex',
                        'justify-self': 'center',
                      }" />
                  } @else {
                    <button class="cds-p-1 cds-flex cds-justify-self-center" (click)="downloadQuote(summary.number)">
                      <cb-icon iconKey="brand-document-pdf" [iconColor]="'neutral-800'" [addPointerClass]="true" />
                    </button>
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      } @else {
        <div class="cds-grid cds-grid-cols-1 sm:cds-grid-cols-2 md:cds-grid-cols-3 cds-gap-4">
          @for (summary of policySummaries(); track summary; let idx = $index) {
            <div
              class="cb-card cb-card--accent-top cb-card--purple-color-theme"
              [attr.data-testid]="`dashboard-card-${idx}`">
              <div class="cb-card__content">
                <div class="cb-card__header">
                  <div class="cb-card__title--marketing">
                    {{ summary.updatedDate | date: 'd MMMM yyyy' }}
                  </div>
                </div>
                <p class="cb-card__text !cds-min-h-16 !cds-line-clamp-2" [title]="summary.comment ?? ''">
                  {{ summary.comment }}
                </p>
                <div class="cds-my-4 cds-grid cds-grid-cols-2 cds-gap-y-2 cds-gap-x-1">
                  <p class="cds-text-desktop-body cds-font-semibold">Policy No.</p>
                  <cb-text-link
                    linkColor="black"
                    class="[&>a]:!cds-m-0"
                    [label]="summary?.number!"
                    [linkConfiguration]="{
                      target: '_self',
                      href: './coverage?policyNumber=' + summary.number,
                    }" />
                  <p class="cds-text-desktop-body cds-font-semibold">Advisor code</p>
                  <p>{{ summary.adviserCode ?? '' }}</p>
                  <p class="cds-text-desktop-body cds-font-semibold">Premium</p>
                  <p>{{ formatPremium(summary.premium) }}</p>
                </div>
                @if (summary.number != null) {
                  @if (variantDownloadQueue().includes(summary.number)) {
                    <p-progress-spinner [style]="{ width: '24px', height: '24px', padding: '4px' }" />
                  } @else {
                    <button (click)="downloadQuote(summary.number)">
                      <cb-icon
                        iconKey="brand-document-pdf"
                        [iconColor]="'neutral-800'"
                        [addPointerClass]="true"
                        iconSize="large" />
                    </button>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
    } @else {
      <div class="cds-flex cds-justify-center cds-my-10">
        <p class="body-regular cds-text-center">
          No QFA available for this policy. Get started by clicking on the "+ New QFA"
        </p>
      </div>
    }
  </div>
</div>
